<ng-template #template>
  <button mat-button class="button--text mat-non-underlined-button" (click)="openReturnDateHelpModal()">
    <span class="label-delivery-date__text--desktop">{{ 'cart.cart-column-returnDate' | translate }}</span>
    <mat-icon>help_outline</mat-icon>
  </button>
</ng-template>

<ng-template #mobileTemplate>
  <div>
    <button mat-button class="mat-non-underlined-button" (click)="openReturnDateHelpModal()">
      <span class="text--label text--line-height-sm">{{ 'cart.cart-column-returnDate' | translate }}</span>
      <mat-icon>help_outline</mat-icon>
    </button>
  </div>
</ng-template>
